<template>
	<div class="breadcrumb-skip">
		<span>您的位置：</span>
		<span v-for="(item, i) in items" :key="i" class="crumb-wrap">
			<span v-if="i > 0" class="crumb-sep"><i class="el-icon-arrow-right"></i></span>
			<span
				class="linke"
				:class="{ on: item.current, 'is-plain': !item.to && !item.current }"
				@click="onClick(item)"
			>{{ item.title }}</span>
		</span>
	</div>
</template>

<script>
import { getDetailBreadcrumbItems } from '@/utils/breadcrumb'

export default {
	name: 'BreadcrumbNav',
	props: {
		columnId: {
			type: [String, Number],
			default: undefined
		},
		tail: {
			type: String,
			default: '详情'
		}
	},
	computed: {
		items() {
			const id = this.columnId !== undefined ? this.columnId : this.$route.query.id
			return getDetailBreadcrumbItems(id, { tail: this.tail })
		}
	},
	methods: {
		onClick(item) {
			if (item.current || !item.to) return
			this.$router.push(item.to)
		}
	}
}
</script>

<style lang="scss" scoped>
.breadcrumb-skip {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	font-size: 13px;
	color: #333;

	.linke {
		cursor: pointer;
	}

	.linke.is-plain {
		cursor: default;
	}

	.linke:hover:not(.is-plain):not(.on),
	.linke.on {
		color: #c7000b;
	}

	.crumb-sep {
		display: inline;
	}
}

@media screen and (max-width: 999px) {
	.breadcrumb-skip {
		font-size: 3.2vw;
	}
}
</style>
